import { multiply, subtract } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";

const TDSDeduction = ({ totalFreight, transportTDS }) => {
  const total = Number(totalFreight ?? 0);
  const TranportTDSValue = Number(transportTDS ?? 0) ;
  const final = multiply(Number(TranportTDSValue ?? 0) / 100, total).toFixed(2);

  return (
  <FormulaLayoutUI>

    <div style={{ marginBottom: "12px" }}>
      <strong style={{ fontSize: "15px" }}>TDS Deduction Formula</strong>
    </div>

    <div
      style={{
        padding: "10px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        fontSize: "13px",
        marginBottom: "10px",
      }}
    >
      <div>
        TDS Deduction = Total Freight × Transporter TDS %
      </div>

      <div style={{ marginTop: "6px", color: "#555" }}>
        = {total} × ({TranportTDSValue} / 100)
      </div>

      <div style={{ marginTop: "6px" }}>
        = {total} × {TranportTDSValue}%
      </div>

      <div
        style={{
          marginTop: "10px",
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        TDS Amount: ₹ {final} /-
      </div>
    </div>

  </FormulaLayoutUI>
);
};

export default TDSDeduction;
